type FetchResponse = {
  ok: boolean
  json?: () => Promise<unknown>
}

type Fetcher = (input: string, init: RequestInit) => Promise<FetchResponse>

function objectPayload(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null
}

export async function submitRecoveredPassword(fetcher: Fetcher, password: string) {
  const response = await fetcher('/auth/update-password/password', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ password })
  })
  const payload = objectPayload(await response.json?.().catch(() => null))
  if (!response.ok || payload?.success !== true) {
    throw new Error(
      typeof payload?.error === 'string' ? payload.error : 'Password update is unavailable.'
    )
  }
  return { success: true as const }
}

export async function clearPasswordRecoveryIntent(fetcher: Fetcher): Promise<void> {
  try {
    await fetcher('/auth/update-password/clear', {
      method: 'POST',
      credentials: 'same-origin'
    })
  } catch {
    // Clearing the short-lived recovery proof is best-effort during sign-out.
    // The server still binds and expires the proof independently.
  }
}
